/* oxlint-disable */
const urls = {"mcp_register":{"route":"/mcp/oauth/register/","args":{}},"mcp_authorize":{"route":"/mcp/oauth/authorize/","args":{}},"mcp_token":{"route":"/mcp/oauth/token/","args":{}},"mcp_icon":{"route":"/mcp/icon.png","args":{}},"mcp":{"route":"/mcp","args":{}},"hijack:acquire":{"route":"/hijack/acquire/","args":{}},"hijack:release":{"route":"/hijack/release/","args":{}},"backoffice_predictions":{"route":"/backoffice/predictions/","args":{}},"backoffice_module":{"route":"/backoffice/<str:module>/","args":{"module":"string"}},"track_email_open":{"route":"/telera/<uuid:email_uuid>/","args":{"email_uuid":"string"}},"hire_registration":{"route":"/pros/<str:handle>/","args":{"handle":"string"}},"program_redirect":{"route":"/pros/programs/<str:product_code>/","args":{"product_code":"string"}},"client_registration":{"route":"/coachmattfried/","args":{}},"manager_registration":{"route":"/managers/register/","args":{}},"confirm_manager":{"route":"/managers/confirm/<uuid:uuid>/","args":{"uuid":"string"}},"redirect_to_client_dashboard":{"route":"/clients/redirect/","args":{}},"merge_exercises":{"route":"/clients/merge-exercises/","args":{}},"exercise_media":{"route":"/admin/exercise-media/","args":{}},"exercise_media_path":{"route":"/admin/exercise-media/<path:_>","args":{"_":"string"}},"strength":{"route":"/strength-standards/","args":{}},"strength_open_graph":{"route":"/strength-standards/og.png","args":{}},"meet_detail":{"route":"/meets/<str:share_uuid>/","args":{"share_uuid":"string"}},"join_meet":{"route":"/meets/<str:share_uuid>/join/","args":{"share_uuid":"string"}},"pull_up":{"route":"/pull-up/","args":{}},"leangains":{"route":"/leangains/","args":{}},"start":{"route":"/start/","args":{}},"migrate":{"route":"/migrate/","args":{}},"contact":{"route":"/contact/","args":{}},"tutorials":{"route":"/tutorials/","args":{}},"share":{"route":"/share/","args":{}},"share_debug":{"route":"/share/debug/<str:uuid>/","args":{"uuid":"string"}},"share_detail":{"route":"/share/<str:uuid>/","args":{"uuid":"string"}},"peptides":{"route":"/peptides/","args":{}},"peptide_open_graph":{"route":"/peptides/og/<slug:slug>.png","args":{"slug":"string"}},"peptide_guide":{"route":"/peptides/<slug:slug>/","args":{"slug":"string"}},"super_smoothies":{"route":"/super-smoothies/","args":{}},"super_smoothies_detail":{"route":"/super-smoothies/<str:share_uuid>/","args":{"share_uuid":"string"}},"storyboard":{"route":"/storyboard/","args":{}},"journal":{"route":"/journal/","args":{}},"calculator":{"route":"/calculator/","args":{}},"macros":{"route":"/macros/","args":{}},"workouts":{"route":"/workouts/","args":{}},"profile":{"route":"/profile/","args":{}},"login":{"route":"/login/","args":{}},"plan_onboarding":{"route":"/plan/","args":{}},"walking_club":{"route":"/club/","args":{}},"walking_club_open_graph":{"route":"/club/og/<slug:code>.png","args":{"code":"string"}},"walking_club_detail":{"route":"/club/<str:code>/","args":{"code":"string"}},"register":{"route":"/register/","args":{}},"reset":{"route":"/reset/","args":{}},"password_reset_confirm":{"route":"/reset/<uidb64>/<token>/","args":{"uidb64":"string","token":"string"}},"load_search_async":{"route":"/api/load-search-async/","args":{}},"clients_list":{"route":"/clients/","args":{}},"business_create":{"route":"/clients/create/","args":{}},"any_client_delete":{"route":"/clients/<int:client_manager_id>/delete/","args":{"client_manager_id":"number"}},"client_detail":{"route":"/clients/<int:client_manager_id>/","args":{"client_manager_id":"number"}},"clients_settings":{"route":"/clients/settings/","args":{}},"business_billing":{"route":"/clients/billing/","args":{}},"meal_plans_list":{"route":"/clients/meal-plans/","args":{}},"meal_plan_detail":{"route":"/clients/meal-plans/<int:meal_plan_id>/","args":{"meal_plan_id":"number"}},"meal_plan_delete":{"route":"/clients/meal-plans/<int:meal_plan_id>/delete/","args":{"meal_plan_id":"number"}},"meal_plans_create":{"route":"/clients/meal-plans/create/","args":{}},"client_planner":{"route":"/clients/<int:client_manager_id>/planner/","args":{"client_manager_id":"number"}},"client_planner_targets_create":{"route":"/clients/<int:client_manager_id>/planner/targets/create/","args":{"client_manager_id":"number"}},"client_planner_targets":{"route":"/clients/<int:client_manager_id>/planner/targets/<int:target_id>/","args":{"client_manager_id":"number","target_id":"number"}},"programs_list":{"route":"/clients/programs/","args":{}},"program_detail":{"route":"/clients/programs/<int:program_id>/","args":{"program_id":"number"}},"client_check_ins":{"route":"/clients/<int:client_manager_id>/check-ins/","args":{"client_manager_id":"number"}},"client_survey":{"route":"/clients/<int:client_manager_id>/survey/","args":{"client_manager_id":"number"}},"client_reports":{"route":"/clients/<int:client_manager_id>/reports/","args":{"client_manager_id":"number"}},"client_days":{"route":"/clients/<int:client_manager_id>/days/<str:date>/","args":{"client_manager_id":"number","date":"string"}},"clients_check_ins":{"route":"/clients/check-ins/","args":{}},"clients_profiles":{"route":"/clients/profiles/","args":{}},"client_supplements":{"route":"/clients/<int:client_manager_id>/supplements/","args":{"client_manager_id":"number"}},"rpc_profile_detail":{"route":"/rpc/profile_detail/","args":{}},"rpc_register":{"route":"/rpc/register/","args":{}},"rpc_check_email":{"route":"/rpc/check_email/","args":{}},"rpc_login":{"route":"/rpc/login/","args":{}},"rpc_set_password":{"route":"/rpc/set_password/","args":{}},"rpc_update_settings":{"route":"/rpc/update_settings/","args":{}},"rpc_apple_ping":{"route":"/rpc/apple_ping/","args":{}},"rpc_track_email_click":{"route":"/rpc/track_email_click/","args":{}},"rpc_register_apns_device":{"route":"/rpc/register_apns_device/","args":{}},"rpc_preview_email":{"route":"/rpc/preview_email/","args":{}},"rpc_link_analytics":{"route":"/rpc/link_analytics/<str:form>/","args":{"form":"string"}},"rpc_postmark_webhook":{"route":"/rpc/postmark_webhook/","args":{}},"rpc_mfp_registration":{"route":"/rpc/mfp_registration/","args":{}},"rpc_learning_week_registration":{"route":"/rpc/learning_week_registration/","args":{}},"rpc_plan_registration":{"route":"/rpc/plan_registration/","args":{}},"rpc_create_user_media_image":{"route":"/rpc/create_user_media_image/","args":{}},"rpc_request_login_link":{"route":"/rpc/request_login_link/","args":{}},"rpc_validate_login_link":{"route":"/rpc/validate_login_link/","args":{}},"rpc_logout":{"route":"/rpc/logout/","args":{}},"rpc_reset_password":{"route":"/rpc/reset_password/","args":{}},"rpc_contact":{"route":"/rpc/contact/","args":{}},"rpc_dismiss_announcement":{"route":"/rpc/dismiss_announcement/","args":{}},"rpc_update_profile":{"route":"/rpc/update_profile/","args":{}},"rpc_delete_profile":{"route":"/rpc/delete_profile/","args":{}},"rpc_get_client_dashboard_link":{"route":"/rpc/get_client_dashboard_link/","args":{}},"rpc_invite_user":{"route":"/rpc/invite_user/","args":{}},"rpc_attribute_share":{"route":"/rpc/attribute_share/","args":{}},"rpc_attribute_utm":{"route":"/rpc/attribute_utm/","args":{}},"rpc_create_tracking_link":{"route":"/rpc/create_tracking_link/","args":{}},"rpc_create_calculator_share":{"route":"/rpc/create_calculator_share/","args":{}},"rpc_validate_iap":{"route":"/rpc/validate_iap/","args":{}},"rpc_verify_apple_transaction":{"route":"/rpc/verify_apple_transaction/","args":{}},"rpc_apple_notification":{"route":"/rpc/apple_notification/","args":{}},"rpc_subscription_detail":{"route":"/rpc/subscription_detail/","args":{}},"rpc_create_subscription":{"route":"/rpc/create_subscription/","args":{}},"rpc_delete_subscription":{"route":"/rpc/delete_subscription/","args":{}},"rpc_create_paypal_subscription":{"route":"/rpc/create_paypal_subscription/","args":{}},"rpc_save":{"route":"/rpc/save/","args":{}},"rpc_update_metrics":{"route":"/rpc/update_metrics/","args":{}},"rpc_update_metric_aggregates":{"route":"/rpc/update_metric_aggregates/","args":{}},"rpc_update_metric_aggregates_native":{"route":"/rpc/update_metric_aggregates_native/","args":{}},"rpc_journal":{"route":"/rpc/journal/","args":{}},"rpc_update_measurements":{"route":"/rpc/update_measurements/","args":{}},"rpc_update_day":{"route":"/rpc/update_day/<int:user_id>/<str:key>/","args":{"user_id":"number","key":"string"}},"rpc_legacy_update_day":{"route":"/rpc/legacy_update_day/","args":{}},"rpc_delete_journal_workout":{"route":"/rpc/delete_journal_workout/","args":{}},"rpc_fast_init":{"route":"/rpc/fast_init/","args":{}},"rpc_planner":{"route":"/rpc/planner/","args":{}},"rpc_consumer_planner":{"route":"/rpc/consumer_planner/","args":{}},"rpc_start":{"route":"/rpc/start/","args":{}},"rpc_method":{"route":"/rpc/method/","args":{}},"rpc_reset_challenge":{"route":"/rpc/reset_challenge/","args":{}},"rpc_shopify_order_created":{"route":"/rpc/shopify_order_created/","args":{}},"rpc_replace_entry":{"route":"/rpc/replace_entry/","args":{}},"rpc_verify_purchase_entitlement":{"route":"/rpc/verify_purchase_entitlement/<str:form>/","args":{"form":"string"}},"rpc_move_day":{"route":"/rpc/move_day/","args":{}},"rpc_copy_day":{"route":"/rpc/copy_day/","args":{}},"rpc_accept_meal_plan":{"route":"/rpc/accept_meal_plan/","args":{}},"rpc_reject_meal_plan":{"route":"/rpc/reject_meal_plan/","args":{}},"rpc_check_in":{"route":"/rpc/check_in/","args":{}},"rpc_target_planner":{"route":"/rpc/target_planner/","args":{}},"rpc_program_detail":{"route":"/rpc/program_detail/<uuid:form>/","args":{"form":"string"}},"rpc_workouts":{"route":"/rpc/workouts/","args":{}},"rpc_create_template_from_workout":{"route":"/rpc/create_template_from_workout/","args":{}},"rpc_delete_workout_template":{"route":"/rpc/delete_workout_template/","args":{}},"rpc_delete_workout":{"route":"/rpc/delete_workout/","args":{}},"rpc_delete_group":{"route":"/rpc/delete_group/","args":{}},"rpc_update_workout":{"route":"/rpc/update_workout/","args":{}},"rpc_update_program":{"route":"/rpc/update_program/","args":{}},"rpc_create_program":{"route":"/rpc/create_program/","args":{}},"rpc_copy_program":{"route":"/rpc/copy_program/","args":{}},"rpc_delete_program":{"route":"/rpc/delete_program/","args":{}},"rpc_select_program_template":{"route":"/rpc/select_program_template/","args":{}},"rpc_preview_program":{"route":"/rpc/preview_program/<uuid:form>/","args":{"form":"string"}},"rpc_create_exercise_types":{"route":"/rpc/create_exercise_types/","args":{}},"rpc_set_exercise_maxes":{"route":"/rpc/set_exercise_maxes/","args":{}},"rpc_delete_exercise_type":{"route":"/rpc/delete_exercise_type/<uuid:source_exercise_type>/","args":{"source_exercise_type":"string"}},"rpc_delete_exercise_group":{"route":"/rpc/delete_exercise_group/","args":{}},"rpc_select_program_workout":{"route":"/rpc/select_program_workout/","args":{}},"rpc_archive_program":{"route":"/rpc/archive_program/","args":{}},"rpc_disable_sync":{"route":"/rpc/disable_sync/","args":{}},"rpc_recent_sections":{"route":"/rpc/recent_sections/","args":{}},"rpc_exercise_media_lookup":{"route":"/rpc/exercise_media_lookup/","args":{}},"rpc_update_exercise_media":{"route":"/rpc/update_exercise_media/","args":{}},"rpc_create_exercise_type":{"route":"/rpc/create_exercise_type/","args":{}},"rpc_update_exercise_type":{"route":"/rpc/update_exercise_type/","args":{}},"rpc_delete_exercise_set":{"route":"/rpc/delete_exercise_set/","args":{}},"rpc_delete_exercise":{"route":"/rpc/delete_exercise/","args":{}},"rpc_clear_exercise_sets":{"route":"/rpc/clear_exercise_sets/","args":{}},"rpc_record_exercise_result":{"route":"/rpc/record_exercise_result/","args":{}},"rpc_exercise_detail":{"route":"/rpc/exercise_detail/","args":{}},"rpc_copy_workout":{"route":"/rpc/copy_workout/","args":{}},"rpc_complete_workout":{"route":"/rpc/complete_workout/","args":{}},"rpc_incomplete_workout":{"route":"/rpc/incomplete_workout/","args":{}},"rpc_create_workout_template":{"route":"/rpc/create_workout_template/","args":{}},"rpc_create_question_type":{"route":"/rpc/create_question_type/","args":{}},"rpc_delete_entry":{"route":"/rpc/delete_entry/<uuid:form>/","args":{"form":"string"}},"rpc_update_cupboard":{"route":"/rpc/update_cupboard/","args":{}},"rpc_update_recipe":{"route":"/rpc/update_recipe/","args":{}},"rpc_predictions_data":{"route":"/rpc/predictions_data/","args":{}},"rpc_load_search":{"route":"/rpc/load_search/","args":{}},"rpc_search":{"route":"/rpc/search/","args":{}},"rpc_publish_nutritional_vision_prompt":{"route":"/rpc/publish_nutritional_vision_prompt/","args":{}},"rpc_publish_day":{"route":"/rpc/publish_day/","args":{}},"rpc_share_detail":{"route":"/rpc/share_detail/","args":{}},"rpc_share_recipe":{"route":"/rpc/share_recipe/","args":{}},"rpc_toggle_recipe_favorite":{"route":"/rpc/toggle_recipe_favorite/<uuid:form>/","args":{"form":"string"}},"rpc_food_list":{"route":"/rpc/food_list/","args":{}},"rpc_create_food":{"route":"/rpc/create_food/","args":{}},"rpc_update_food":{"route":"/rpc/update_food/","args":{}},"rpc_delete_food":{"route":"/rpc/delete_food/","args":{}},"rpc_recipe_list":{"route":"/rpc/recipe_list/","args":{}},"rpc_create_recipe":{"route":"/rpc/create_recipe/","args":{}},"rpc_update_recipe_metadata":{"route":"/rpc/update_recipe_metadata/","args":{}},"rpc_delete_recipe":{"route":"/rpc/delete_recipe/","args":{}},"rpc_copy_recipe":{"route":"/rpc/copy_recipe/","args":{}},"rpc_create_recipe_from_meal":{"route":"/rpc/create_recipe_from_meal/","args":{}},"rpc_publish_meal":{"route":"/rpc/publish_meal/","args":{}},"rpc_delete_meal":{"route":"/rpc/delete_meal/","args":{}},"rpc_move_meal":{"route":"/rpc/move_meal/","args":{}},"rpc_copy_meal":{"route":"/rpc/copy_meal/","args":{}},"rpc_publish_entry":{"route":"/rpc/publish_entry/","args":{}},"rpc_expand_entry":{"route":"/rpc/expand_entry/","args":{}},"rpc_reports":{"route":"/rpc/reports/","args":{}},"rpc_weekly_macros":{"route":"/rpc/weekly_macros/","args":{}},"rpc_mfp_migration_detail":{"route":"/rpc/mfp_migration_detail/","args":{}},"rpc_create_mfp_account":{"route":"/rpc/create_mfp_account/","args":{}},"rpc_walking_club_board":{"route":"/rpc/walking_club_board/","args":{}},"rpc_walking_club_demo_allowed":{"route":"/rpc/walking_club_demo_allowed/","args":{}},"rpc_walking_club_info":{"route":"/rpc/walking_club_info/","args":{}},"rpc_walking_club_login_link":{"route":"/rpc/walking_club_login_link/","args":{}},"rpc_walking_club_join":{"route":"/rpc/walking_club_join/","args":{}},"rpc_walking_club_registration":{"route":"/rpc/walking_club_registration/","args":{}},"rpc_onboarding_registration":{"route":"/rpc/onboarding_registration/","args":{}},"rpc_save_macros":{"route":"/rpc/save_macros/","args":{}},"rpc_queue_meal_image":{"route":"/rpc/queue_meal_image/","args":{}},"rpc_identify_meal_name":{"route":"/rpc/identify_meal_name/<uuid:form>/","args":{"form":"string"}},"rpc_queue_barcode":{"route":"/rpc/queue_barcode/","args":{}},"rpc_process_queued_barcode":{"route":"/rpc/process_queued_barcode/<uuid:form>/","args":{"form":"string"}},"rpc_process_queued_image":{"route":"/rpc/process_queued_image/<uuid:form>/","args":{"form":"string"}},"rpc_reprocess_queued_image":{"route":"/rpc/reprocess_queued_image/","args":{}},"rpc_queue_audio_transcription":{"route":"/rpc/queue_audio_transcription/<str:form>/","args":{"form":"string"}},"rpc_process_queued_audio":{"route":"/rpc/process_queued_audio/<uuid:form>/","args":{"form":"string"}},"rpc_import_recipe":{"route":"/rpc/import_recipe/","args":{}},"rpc_peptides":{"route":"/rpc/peptides/","args":{}},"rpc_create_peptide_vial":{"route":"/rpc/create_peptide_vial/","args":{}},"rpc_delete_peptide_vial":{"route":"/rpc/delete_peptide_vial/","args":{}},"rpc_create_peptide_dose":{"route":"/rpc/create_peptide_dose/","args":{}},"rpc_strength":{"route":"/rpc/strength/","args":{}},"rpc_update_meet":{"route":"/rpc/update_meet/","args":{}},"rpc_instacart_recipe":{"route":"/rpc/instacart_recipe/","args":{}},"rpc_usda_foods":{"route":"/rpc/usda_foods/","args":{}},"rpc_export_journal":{"route":"/rpc/export_journal/","args":{}},"rpc_get_available_prediction_users":{"route":"/rpc/get_available_prediction_users/","args":{}},"get_tus_upload_url":{"route":"/get-tus-upload-url/","args":{}},"billing":{"route":"/billing/","args":{}},"paypal_redirect":{"route":"/paypal/","args":{}},"business_page":{"route":"/business/","args":{}},"business_demo":{"route":"/business/demo/","args":{}},"five_three_one":{"route":"/531/","args":{}},"home_page":{"route":"/","args":{}},"download":{"route":"/download/","args":{}},"review_redirect":{"route":"/links/review/","args":{}},"chandler":{"route":"/chandler/","args":{}},"support_user":{"route":"/support/<int:user_id>/","args":{"user_id":"number"}},"csrf":{"route":"/api/csrf/","args":{}},"credentials":{"route":"/api/credentials/","args":{}},"sync_sleep":{"route":"/api/sync/","args":{}},"async_sleep":{"route":"/api/async/","args":{}},"sesame_login":{"route":"/sesame/login/","args":{}},"demo_setup":{"route":"/admin/demo/","args":{}},"terms_of_service":{"route":"/terms-of-service/","args":{}},"privacy_policy":{"route":"/privacy-policy/","args":{}},"robots_txt":{"route":"/robots.txt","args":{}},"sitemap_xml":{"route":"/sitemap.xml","args":{}},"apple_app_site_association":{"route":"/.well-known/apple-app-site-association","args":{}},"android_app_site_association":{"route":"/.well-known/assetlinks.json","args":{}},"serve_static":{"route":"/static/<path:path>","args":{"path":"string"}},"__reactivated_do_not_use":{"route":"__reactivated_do_not_use","args":{}},"__reactivated_do_not_use_args":{"route":"__reactivated_do_not_use_args","args":{"_":"string"}}};

interface URLMap {
    mcp_register: mcp_register;
    mcp_authorize: mcp_authorize;
    mcp_token: mcp_token;
    mcp_icon: mcp_icon;
    mcp: mcp;
    hijack_acquire: hijack_acquire;
    hijack_release: hijack_release;
    backoffice_predictions: backoffice_predictions;
    backoffice_module: backoffice_module;
    track_email_open: track_email_open;
    hire_registration: hire_registration;
    program_redirect: program_redirect;
    client_registration: client_registration;
    manager_registration: manager_registration;
    confirm_manager: confirm_manager;
    redirect_to_client_dashboard: redirect_to_client_dashboard;
    merge_exercises: merge_exercises;
    exercise_media: exercise_media;
    exercise_media_path: exercise_media_path;
    strength: strength;
    strength_open_graph: strength_open_graph;
    meet_detail: meet_detail;
    join_meet: join_meet;
    pull_up: pull_up;
    leangains: leangains;
    start: start;
    migrate: migrate;
    contact: contact;
    tutorials: tutorials;
    share: share;
    share_debug: share_debug;
    share_detail: share_detail;
    peptides: peptides;
    peptide_open_graph: peptide_open_graph;
    peptide_guide: peptide_guide;
    super_smoothies: super_smoothies;
    super_smoothies_detail: super_smoothies_detail;
    storyboard: storyboard;
    journal: journal;
    calculator: calculator;
    macros: macros;
    workouts: workouts;
    profile: profile;
    login: login;
    plan_onboarding: plan_onboarding;
    walking_club: walking_club;
    walking_club_open_graph: walking_club_open_graph;
    walking_club_detail: walking_club_detail;
    register: register;
    reset: reset;
    password_reset_confirm: password_reset_confirm;
    load_search_async: load_search_async;
    clients_list: clients_list;
    business_create: business_create;
    any_client_delete: any_client_delete;
    client_detail: client_detail;
    clients_settings: clients_settings;
    business_billing: business_billing;
    meal_plans_list: meal_plans_list;
    meal_plan_detail: meal_plan_detail;
    meal_plan_delete: meal_plan_delete;
    meal_plans_create: meal_plans_create;
    client_planner: client_planner;
    client_planner_targets_create: client_planner_targets_create;
    client_planner_targets: client_planner_targets;
    programs_list: programs_list;
    program_detail: program_detail;
    client_check_ins: client_check_ins;
    client_survey: client_survey;
    client_reports: client_reports;
    client_days: client_days;
    clients_check_ins: clients_check_ins;
    clients_profiles: clients_profiles;
    client_supplements: client_supplements;
    rpc_profile_detail: rpc_profile_detail;
    rpc_register: rpc_register;
    rpc_check_email: rpc_check_email;
    rpc_login: rpc_login;
    rpc_set_password: rpc_set_password;
    rpc_update_settings: rpc_update_settings;
    rpc_apple_ping: rpc_apple_ping;
    rpc_track_email_click: rpc_track_email_click;
    rpc_register_apns_device: rpc_register_apns_device;
    rpc_preview_email: rpc_preview_email;
    rpc_link_analytics: rpc_link_analytics;
    rpc_postmark_webhook: rpc_postmark_webhook;
    rpc_mfp_registration: rpc_mfp_registration;
    rpc_learning_week_registration: rpc_learning_week_registration;
    rpc_plan_registration: rpc_plan_registration;
    rpc_create_user_media_image: rpc_create_user_media_image;
    rpc_request_login_link: rpc_request_login_link;
    rpc_validate_login_link: rpc_validate_login_link;
    rpc_logout: rpc_logout;
    rpc_reset_password: rpc_reset_password;
    rpc_contact: rpc_contact;
    rpc_dismiss_announcement: rpc_dismiss_announcement;
    rpc_update_profile: rpc_update_profile;
    rpc_delete_profile: rpc_delete_profile;
    rpc_get_client_dashboard_link: rpc_get_client_dashboard_link;
    rpc_invite_user: rpc_invite_user;
    rpc_attribute_share: rpc_attribute_share;
    rpc_attribute_utm: rpc_attribute_utm;
    rpc_create_tracking_link: rpc_create_tracking_link;
    rpc_create_calculator_share: rpc_create_calculator_share;
    rpc_validate_iap: rpc_validate_iap;
    rpc_verify_apple_transaction: rpc_verify_apple_transaction;
    rpc_apple_notification: rpc_apple_notification;
    rpc_subscription_detail: rpc_subscription_detail;
    rpc_create_subscription: rpc_create_subscription;
    rpc_delete_subscription: rpc_delete_subscription;
    rpc_create_paypal_subscription: rpc_create_paypal_subscription;
    rpc_save: rpc_save;
    rpc_update_metrics: rpc_update_metrics;
    rpc_update_metric_aggregates: rpc_update_metric_aggregates;
    rpc_update_metric_aggregates_native: rpc_update_metric_aggregates_native;
    rpc_journal: rpc_journal;
    rpc_update_measurements: rpc_update_measurements;
    rpc_update_day: rpc_update_day;
    rpc_legacy_update_day: rpc_legacy_update_day;
    rpc_delete_journal_workout: rpc_delete_journal_workout;
    rpc_fast_init: rpc_fast_init;
    rpc_planner: rpc_planner;
    rpc_consumer_planner: rpc_consumer_planner;
    rpc_start: rpc_start;
    rpc_method: rpc_method;
    rpc_reset_challenge: rpc_reset_challenge;
    rpc_shopify_order_created: rpc_shopify_order_created;
    rpc_replace_entry: rpc_replace_entry;
    rpc_verify_purchase_entitlement: rpc_verify_purchase_entitlement;
    rpc_move_day: rpc_move_day;
    rpc_copy_day: rpc_copy_day;
    rpc_accept_meal_plan: rpc_accept_meal_plan;
    rpc_reject_meal_plan: rpc_reject_meal_plan;
    rpc_check_in: rpc_check_in;
    rpc_target_planner: rpc_target_planner;
    rpc_program_detail: rpc_program_detail;
    rpc_workouts: rpc_workouts;
    rpc_create_template_from_workout: rpc_create_template_from_workout;
    rpc_delete_workout_template: rpc_delete_workout_template;
    rpc_delete_workout: rpc_delete_workout;
    rpc_delete_group: rpc_delete_group;
    rpc_update_workout: rpc_update_workout;
    rpc_update_program: rpc_update_program;
    rpc_create_program: rpc_create_program;
    rpc_copy_program: rpc_copy_program;
    rpc_delete_program: rpc_delete_program;
    rpc_select_program_template: rpc_select_program_template;
    rpc_preview_program: rpc_preview_program;
    rpc_create_exercise_types: rpc_create_exercise_types;
    rpc_set_exercise_maxes: rpc_set_exercise_maxes;
    rpc_delete_exercise_type: rpc_delete_exercise_type;
    rpc_delete_exercise_group: rpc_delete_exercise_group;
    rpc_select_program_workout: rpc_select_program_workout;
    rpc_archive_program: rpc_archive_program;
    rpc_disable_sync: rpc_disable_sync;
    rpc_recent_sections: rpc_recent_sections;
    rpc_exercise_media_lookup: rpc_exercise_media_lookup;
    rpc_update_exercise_media: rpc_update_exercise_media;
    rpc_create_exercise_type: rpc_create_exercise_type;
    rpc_update_exercise_type: rpc_update_exercise_type;
    rpc_delete_exercise_set: rpc_delete_exercise_set;
    rpc_delete_exercise: rpc_delete_exercise;
    rpc_clear_exercise_sets: rpc_clear_exercise_sets;
    rpc_record_exercise_result: rpc_record_exercise_result;
    rpc_exercise_detail: rpc_exercise_detail;
    rpc_copy_workout: rpc_copy_workout;
    rpc_complete_workout: rpc_complete_workout;
    rpc_incomplete_workout: rpc_incomplete_workout;
    rpc_create_workout_template: rpc_create_workout_template;
    rpc_create_question_type: rpc_create_question_type;
    rpc_delete_entry: rpc_delete_entry;
    rpc_update_cupboard: rpc_update_cupboard;
    rpc_update_recipe: rpc_update_recipe;
    rpc_predictions_data: rpc_predictions_data;
    rpc_load_search: rpc_load_search;
    rpc_search: rpc_search;
    rpc_publish_nutritional_vision_prompt: rpc_publish_nutritional_vision_prompt;
    rpc_publish_day: rpc_publish_day;
    rpc_share_detail: rpc_share_detail;
    rpc_share_recipe: rpc_share_recipe;
    rpc_toggle_recipe_favorite: rpc_toggle_recipe_favorite;
    rpc_food_list: rpc_food_list;
    rpc_create_food: rpc_create_food;
    rpc_update_food: rpc_update_food;
    rpc_delete_food: rpc_delete_food;
    rpc_recipe_list: rpc_recipe_list;
    rpc_create_recipe: rpc_create_recipe;
    rpc_update_recipe_metadata: rpc_update_recipe_metadata;
    rpc_delete_recipe: rpc_delete_recipe;
    rpc_copy_recipe: rpc_copy_recipe;
    rpc_create_recipe_from_meal: rpc_create_recipe_from_meal;
    rpc_publish_meal: rpc_publish_meal;
    rpc_delete_meal: rpc_delete_meal;
    rpc_move_meal: rpc_move_meal;
    rpc_copy_meal: rpc_copy_meal;
    rpc_publish_entry: rpc_publish_entry;
    rpc_expand_entry: rpc_expand_entry;
    rpc_reports: rpc_reports;
    rpc_weekly_macros: rpc_weekly_macros;
    rpc_mfp_migration_detail: rpc_mfp_migration_detail;
    rpc_create_mfp_account: rpc_create_mfp_account;
    rpc_walking_club_board: rpc_walking_club_board;
    rpc_walking_club_demo_allowed: rpc_walking_club_demo_allowed;
    rpc_walking_club_info: rpc_walking_club_info;
    rpc_walking_club_login_link: rpc_walking_club_login_link;
    rpc_walking_club_join: rpc_walking_club_join;
    rpc_walking_club_registration: rpc_walking_club_registration;
    rpc_onboarding_registration: rpc_onboarding_registration;
    rpc_save_macros: rpc_save_macros;
    rpc_queue_meal_image: rpc_queue_meal_image;
    rpc_identify_meal_name: rpc_identify_meal_name;
    rpc_queue_barcode: rpc_queue_barcode;
    rpc_process_queued_barcode: rpc_process_queued_barcode;
    rpc_process_queued_image: rpc_process_queued_image;
    rpc_reprocess_queued_image: rpc_reprocess_queued_image;
    rpc_queue_audio_transcription: rpc_queue_audio_transcription;
    rpc_process_queued_audio: rpc_process_queued_audio;
    rpc_import_recipe: rpc_import_recipe;
    rpc_peptides: rpc_peptides;
    rpc_create_peptide_vial: rpc_create_peptide_vial;
    rpc_delete_peptide_vial: rpc_delete_peptide_vial;
    rpc_create_peptide_dose: rpc_create_peptide_dose;
    rpc_strength: rpc_strength;
    rpc_update_meet: rpc_update_meet;
    rpc_instacart_recipe: rpc_instacart_recipe;
    rpc_usda_foods: rpc_usda_foods;
    rpc_export_journal: rpc_export_journal;
    rpc_get_available_prediction_users: rpc_get_available_prediction_users;
    get_tus_upload_url: get_tus_upload_url;
    billing: billing;
    paypal_redirect: paypal_redirect;
    business_page: business_page;
    business_demo: business_demo;
    five_three_one: five_three_one;
    home_page: home_page;
    download: download;
    review_redirect: review_redirect;
    chandler: chandler;
    support_user: support_user;
    csrf: csrf;
    credentials: credentials;
    sync_sleep: sync_sleep;
    async_sleep: async_sleep;
    sesame_login: sesame_login;
    demo_setup: demo_setup;
    terms_of_service: terms_of_service;
    privacy_policy: privacy_policy;
    robots_txt: robots_txt;
    sitemap_xml: sitemap_xml;
    apple_app_site_association: apple_app_site_association;
    android_app_site_association: android_app_site_association;
    serve_static: serve_static;
    __reactivated_do_not_use: __reactivated_do_not_use;
    __reactivated_do_not_use_args: __reactivated_do_not_use_args;
}

interface mcp_register {
    name: 'mcp_register';
    args: mcp_register_args;
}

interface mcp_register_args {
}

interface mcp_authorize {
    name: 'mcp_authorize';
    args: mcp_authorize_args;
}

interface mcp_authorize_args {
}

interface mcp_token {
    name: 'mcp_token';
    args: mcp_token_args;
}

interface mcp_token_args {
}

interface mcp_icon {
    name: 'mcp_icon';
    args: mcp_icon_args;
}

interface mcp_icon_args {
}

interface mcp {
    name: 'mcp';
    args: mcp_args;
}

interface mcp_args {
}

interface hijack_acquire {
    name: 'hijack:acquire';
    args: hijack_acquire_args;
}

interface hijack_acquire_args {
}

interface hijack_release {
    name: 'hijack:release';
    args: hijack_release_args;
}

interface hijack_release_args {
}

interface backoffice_predictions {
    name: 'backoffice_predictions';
    args: backoffice_predictions_args;
}

interface backoffice_predictions_args {
}

interface backoffice_module {
    name: 'backoffice_module';
    args: backoffice_module_args;
}

interface backoffice_module_args {
    module: string;
}

interface track_email_open {
    name: 'track_email_open';
    args: track_email_open_args;
}

interface track_email_open_args {
    email_uuid: string;
}

interface hire_registration {
    name: 'hire_registration';
    args: hire_registration_args;
}

interface hire_registration_args {
    handle: string;
}

interface program_redirect {
    name: 'program_redirect';
    args: program_redirect_args;
}

interface program_redirect_args {
    product_code: string;
}

interface client_registration {
    name: 'client_registration';
    args: client_registration_args;
}

interface client_registration_args {
}

interface manager_registration {
    name: 'manager_registration';
    args: manager_registration_args;
}

interface manager_registration_args {
}

interface confirm_manager {
    name: 'confirm_manager';
    args: confirm_manager_args;
}

interface confirm_manager_args {
    uuid: string;
}

interface redirect_to_client_dashboard {
    name: 'redirect_to_client_dashboard';
    args: redirect_to_client_dashboard_args;
}

interface redirect_to_client_dashboard_args {
}

interface merge_exercises {
    name: 'merge_exercises';
    args: merge_exercises_args;
}

interface merge_exercises_args {
}

interface exercise_media {
    name: 'exercise_media';
    args: exercise_media_args;
}

interface exercise_media_args {
}

interface exercise_media_path {
    name: 'exercise_media_path';
    args: exercise_media_path_args;
}

interface exercise_media_path_args {
    _: string;
}

interface strength {
    name: 'strength';
    args: strength_args;
}

interface strength_args {
}

interface strength_open_graph {
    name: 'strength_open_graph';
    args: strength_open_graph_args;
}

interface strength_open_graph_args {
}

interface meet_detail {
    name: 'meet_detail';
    args: meet_detail_args;
}

interface meet_detail_args {
    share_uuid: string;
}

interface join_meet {
    name: 'join_meet';
    args: join_meet_args;
}

interface join_meet_args {
    share_uuid: string;
}

interface pull_up {
    name: 'pull_up';
    args: pull_up_args;
}

interface pull_up_args {
}

interface leangains {
    name: 'leangains';
    args: leangains_args;
}

interface leangains_args {
}

interface start {
    name: 'start';
    args: start_args;
}

interface start_args {
}

interface migrate {
    name: 'migrate';
    args: migrate_args;
}

interface migrate_args {
}

interface contact {
    name: 'contact';
    args: contact_args;
}

interface contact_args {
}

interface tutorials {
    name: 'tutorials';
    args: tutorials_args;
}

interface tutorials_args {
}

interface share {
    name: 'share';
    args: share_args;
}

interface share_args {
}

interface share_debug {
    name: 'share_debug';
    args: share_debug_args;
}

interface share_debug_args {
    uuid: string;
}

interface share_detail {
    name: 'share_detail';
    args: share_detail_args;
}

interface share_detail_args {
    uuid: string;
}

interface peptides {
    name: 'peptides';
    args: peptides_args;
}

interface peptides_args {
}

interface peptide_open_graph {
    name: 'peptide_open_graph';
    args: peptide_open_graph_args;
}

interface peptide_open_graph_args {
    slug: string;
}

interface peptide_guide {
    name: 'peptide_guide';
    args: peptide_guide_args;
}

interface peptide_guide_args {
    slug: string;
}

interface super_smoothies {
    name: 'super_smoothies';
    args: super_smoothies_args;
}

interface super_smoothies_args {
}

interface super_smoothies_detail {
    name: 'super_smoothies_detail';
    args: super_smoothies_detail_args;
}

interface super_smoothies_detail_args {
    share_uuid: string;
}

interface storyboard {
    name: 'storyboard';
    args: storyboard_args;
}

interface storyboard_args {
}

interface journal {
    name: 'journal';
    args: journal_args;
}

interface journal_args {
}

interface calculator {
    name: 'calculator';
    args: calculator_args;
}

interface calculator_args {
}

interface macros {
    name: 'macros';
    args: macros_args;
}

interface macros_args {
}

interface workouts {
    name: 'workouts';
    args: workouts_args;
}

interface workouts_args {
}

interface profile {
    name: 'profile';
    args: profile_args;
}

interface profile_args {
}

interface login {
    name: 'login';
    args: login_args;
}

interface login_args {
}

interface plan_onboarding {
    name: 'plan_onboarding';
    args: plan_onboarding_args;
}

interface plan_onboarding_args {
}

interface walking_club {
    name: 'walking_club';
    args: walking_club_args;
}

interface walking_club_args {
}

interface walking_club_open_graph {
    name: 'walking_club_open_graph';
    args: walking_club_open_graph_args;
}

interface walking_club_open_graph_args {
    code: string;
}

interface walking_club_detail {
    name: 'walking_club_detail';
    args: walking_club_detail_args;
}

interface walking_club_detail_args {
    code: string;
}

interface register {
    name: 'register';
    args: register_args;
}

interface register_args {
}

interface reset {
    name: 'reset';
    args: reset_args;
}

interface reset_args {
}

interface password_reset_confirm {
    name: 'password_reset_confirm';
    args: password_reset_confirm_args;
}

interface password_reset_confirm_args {
    uidb64: string;
    token: string;
}

interface load_search_async {
    name: 'load_search_async';
    args: load_search_async_args;
}

interface load_search_async_args {
}

interface clients_list {
    name: 'clients_list';
    args: clients_list_args;
}

interface clients_list_args {
}

interface business_create {
    name: 'business_create';
    args: business_create_args;
}

interface business_create_args {
}

interface any_client_delete {
    name: 'any_client_delete';
    args: any_client_delete_args;
}

interface any_client_delete_args {
    client_manager_id: number;
}

interface client_detail {
    name: 'client_detail';
    args: client_detail_args;
}

interface client_detail_args {
    client_manager_id: number;
}

interface clients_settings {
    name: 'clients_settings';
    args: clients_settings_args;
}

interface clients_settings_args {
}

interface business_billing {
    name: 'business_billing';
    args: business_billing_args;
}

interface business_billing_args {
}

interface meal_plans_list {
    name: 'meal_plans_list';
    args: meal_plans_list_args;
}

interface meal_plans_list_args {
}

interface meal_plan_detail {
    name: 'meal_plan_detail';
    args: meal_plan_detail_args;
}

interface meal_plan_detail_args {
    meal_plan_id: number;
}

interface meal_plan_delete {
    name: 'meal_plan_delete';
    args: meal_plan_delete_args;
}

interface meal_plan_delete_args {
    meal_plan_id: number;
}

interface meal_plans_create {
    name: 'meal_plans_create';
    args: meal_plans_create_args;
}

interface meal_plans_create_args {
}

interface client_planner {
    name: 'client_planner';
    args: client_planner_args;
}

interface client_planner_args {
    client_manager_id: number;
}

interface client_planner_targets_create {
    name: 'client_planner_targets_create';
    args: client_planner_targets_create_args;
}

interface client_planner_targets_create_args {
    client_manager_id: number;
}

interface client_planner_targets {
    name: 'client_planner_targets';
    args: client_planner_targets_args;
}

interface client_planner_targets_args {
    client_manager_id: number;
    target_id: number;
}

interface programs_list {
    name: 'programs_list';
    args: programs_list_args;
}

interface programs_list_args {
}

interface program_detail {
    name: 'program_detail';
    args: program_detail_args;
}

interface program_detail_args {
    program_id: number;
}

interface client_check_ins {
    name: 'client_check_ins';
    args: client_check_ins_args;
}

interface client_check_ins_args {
    client_manager_id: number;
}

interface client_survey {
    name: 'client_survey';
    args: client_survey_args;
}

interface client_survey_args {
    client_manager_id: number;
}

interface client_reports {
    name: 'client_reports';
    args: client_reports_args;
}

interface client_reports_args {
    client_manager_id: number;
}

interface client_days {
    name: 'client_days';
    args: client_days_args;
}

interface client_days_args {
    client_manager_id: number;
    date: string;
}

interface clients_check_ins {
    name: 'clients_check_ins';
    args: clients_check_ins_args;
}

interface clients_check_ins_args {
}

interface clients_profiles {
    name: 'clients_profiles';
    args: clients_profiles_args;
}

interface clients_profiles_args {
}

interface client_supplements {
    name: 'client_supplements';
    args: client_supplements_args;
}

interface client_supplements_args {
    client_manager_id: number;
}

interface rpc_profile_detail {
    name: 'rpc_profile_detail';
    args: rpc_profile_detail_args;
}

interface rpc_profile_detail_args {
}

interface rpc_register {
    name: 'rpc_register';
    args: rpc_register_args;
}

interface rpc_register_args {
}

interface rpc_check_email {
    name: 'rpc_check_email';
    args: rpc_check_email_args;
}

interface rpc_check_email_args {
}

interface rpc_login {
    name: 'rpc_login';
    args: rpc_login_args;
}

interface rpc_login_args {
}

interface rpc_set_password {
    name: 'rpc_set_password';
    args: rpc_set_password_args;
}

interface rpc_set_password_args {
}

interface rpc_update_settings {
    name: 'rpc_update_settings';
    args: rpc_update_settings_args;
}

interface rpc_update_settings_args {
}

interface rpc_apple_ping {
    name: 'rpc_apple_ping';
    args: rpc_apple_ping_args;
}

interface rpc_apple_ping_args {
}

interface rpc_track_email_click {
    name: 'rpc_track_email_click';
    args: rpc_track_email_click_args;
}

interface rpc_track_email_click_args {
}

interface rpc_register_apns_device {
    name: 'rpc_register_apns_device';
    args: rpc_register_apns_device_args;
}

interface rpc_register_apns_device_args {
}

interface rpc_preview_email {
    name: 'rpc_preview_email';
    args: rpc_preview_email_args;
}

interface rpc_preview_email_args {
}

interface rpc_link_analytics {
    name: 'rpc_link_analytics';
    args: rpc_link_analytics_args;
}

interface rpc_link_analytics_args {
    form: string;
}

interface rpc_postmark_webhook {
    name: 'rpc_postmark_webhook';
    args: rpc_postmark_webhook_args;
}

interface rpc_postmark_webhook_args {
}

interface rpc_mfp_registration {
    name: 'rpc_mfp_registration';
    args: rpc_mfp_registration_args;
}

interface rpc_mfp_registration_args {
}

interface rpc_learning_week_registration {
    name: 'rpc_learning_week_registration';
    args: rpc_learning_week_registration_args;
}

interface rpc_learning_week_registration_args {
}

interface rpc_plan_registration {
    name: 'rpc_plan_registration';
    args: rpc_plan_registration_args;
}

interface rpc_plan_registration_args {
}

interface rpc_create_user_media_image {
    name: 'rpc_create_user_media_image';
    args: rpc_create_user_media_image_args;
}

interface rpc_create_user_media_image_args {
}

interface rpc_request_login_link {
    name: 'rpc_request_login_link';
    args: rpc_request_login_link_args;
}

interface rpc_request_login_link_args {
}

interface rpc_validate_login_link {
    name: 'rpc_validate_login_link';
    args: rpc_validate_login_link_args;
}

interface rpc_validate_login_link_args {
}

interface rpc_logout {
    name: 'rpc_logout';
    args: rpc_logout_args;
}

interface rpc_logout_args {
}

interface rpc_reset_password {
    name: 'rpc_reset_password';
    args: rpc_reset_password_args;
}

interface rpc_reset_password_args {
}

interface rpc_contact {
    name: 'rpc_contact';
    args: rpc_contact_args;
}

interface rpc_contact_args {
}

interface rpc_dismiss_announcement {
    name: 'rpc_dismiss_announcement';
    args: rpc_dismiss_announcement_args;
}

interface rpc_dismiss_announcement_args {
}

interface rpc_update_profile {
    name: 'rpc_update_profile';
    args: rpc_update_profile_args;
}

interface rpc_update_profile_args {
}

interface rpc_delete_profile {
    name: 'rpc_delete_profile';
    args: rpc_delete_profile_args;
}

interface rpc_delete_profile_args {
}

interface rpc_get_client_dashboard_link {
    name: 'rpc_get_client_dashboard_link';
    args: rpc_get_client_dashboard_link_args;
}

interface rpc_get_client_dashboard_link_args {
}

interface rpc_invite_user {
    name: 'rpc_invite_user';
    args: rpc_invite_user_args;
}

interface rpc_invite_user_args {
}

interface rpc_attribute_share {
    name: 'rpc_attribute_share';
    args: rpc_attribute_share_args;
}

interface rpc_attribute_share_args {
}

interface rpc_attribute_utm {
    name: 'rpc_attribute_utm';
    args: rpc_attribute_utm_args;
}

interface rpc_attribute_utm_args {
}

interface rpc_create_tracking_link {
    name: 'rpc_create_tracking_link';
    args: rpc_create_tracking_link_args;
}

interface rpc_create_tracking_link_args {
}

interface rpc_create_calculator_share {
    name: 'rpc_create_calculator_share';
    args: rpc_create_calculator_share_args;
}

interface rpc_create_calculator_share_args {
}

interface rpc_validate_iap {
    name: 'rpc_validate_iap';
    args: rpc_validate_iap_args;
}

interface rpc_validate_iap_args {
}

interface rpc_verify_apple_transaction {
    name: 'rpc_verify_apple_transaction';
    args: rpc_verify_apple_transaction_args;
}

interface rpc_verify_apple_transaction_args {
}

interface rpc_apple_notification {
    name: 'rpc_apple_notification';
    args: rpc_apple_notification_args;
}

interface rpc_apple_notification_args {
}

interface rpc_subscription_detail {
    name: 'rpc_subscription_detail';
    args: rpc_subscription_detail_args;
}

interface rpc_subscription_detail_args {
}

interface rpc_create_subscription {
    name: 'rpc_create_subscription';
    args: rpc_create_subscription_args;
}

interface rpc_create_subscription_args {
}

interface rpc_delete_subscription {
    name: 'rpc_delete_subscription';
    args: rpc_delete_subscription_args;
}

interface rpc_delete_subscription_args {
}

interface rpc_create_paypal_subscription {
    name: 'rpc_create_paypal_subscription';
    args: rpc_create_paypal_subscription_args;
}

interface rpc_create_paypal_subscription_args {
}

interface rpc_save {
    name: 'rpc_save';
    args: rpc_save_args;
}

interface rpc_save_args {
}

interface rpc_update_metrics {
    name: 'rpc_update_metrics';
    args: rpc_update_metrics_args;
}

interface rpc_update_metrics_args {
}

interface rpc_update_metric_aggregates {
    name: 'rpc_update_metric_aggregates';
    args: rpc_update_metric_aggregates_args;
}

interface rpc_update_metric_aggregates_args {
}

interface rpc_update_metric_aggregates_native {
    name: 'rpc_update_metric_aggregates_native';
    args: rpc_update_metric_aggregates_native_args;
}

interface rpc_update_metric_aggregates_native_args {
}

interface rpc_journal {
    name: 'rpc_journal';
    args: rpc_journal_args;
}

interface rpc_journal_args {
}

interface rpc_update_measurements {
    name: 'rpc_update_measurements';
    args: rpc_update_measurements_args;
}

interface rpc_update_measurements_args {
}

interface rpc_update_day {
    name: 'rpc_update_day';
    args: rpc_update_day_args;
}

interface rpc_update_day_args {
    user_id: number;
    key: string;
}

interface rpc_legacy_update_day {
    name: 'rpc_legacy_update_day';
    args: rpc_legacy_update_day_args;
}

interface rpc_legacy_update_day_args {
}

interface rpc_delete_journal_workout {
    name: 'rpc_delete_journal_workout';
    args: rpc_delete_journal_workout_args;
}

interface rpc_delete_journal_workout_args {
}

interface rpc_fast_init {
    name: 'rpc_fast_init';
    args: rpc_fast_init_args;
}

interface rpc_fast_init_args {
}

interface rpc_planner {
    name: 'rpc_planner';
    args: rpc_planner_args;
}

interface rpc_planner_args {
}

interface rpc_consumer_planner {
    name: 'rpc_consumer_planner';
    args: rpc_consumer_planner_args;
}

interface rpc_consumer_planner_args {
}

interface rpc_start {
    name: 'rpc_start';
    args: rpc_start_args;
}

interface rpc_start_args {
}

interface rpc_method {
    name: 'rpc_method';
    args: rpc_method_args;
}

interface rpc_method_args {
}

interface rpc_reset_challenge {
    name: 'rpc_reset_challenge';
    args: rpc_reset_challenge_args;
}

interface rpc_reset_challenge_args {
}

interface rpc_shopify_order_created {
    name: 'rpc_shopify_order_created';
    args: rpc_shopify_order_created_args;
}

interface rpc_shopify_order_created_args {
}

interface rpc_replace_entry {
    name: 'rpc_replace_entry';
    args: rpc_replace_entry_args;
}

interface rpc_replace_entry_args {
}

interface rpc_verify_purchase_entitlement {
    name: 'rpc_verify_purchase_entitlement';
    args: rpc_verify_purchase_entitlement_args;
}

interface rpc_verify_purchase_entitlement_args {
    form: string;
}

interface rpc_move_day {
    name: 'rpc_move_day';
    args: rpc_move_day_args;
}

interface rpc_move_day_args {
}

interface rpc_copy_day {
    name: 'rpc_copy_day';
    args: rpc_copy_day_args;
}

interface rpc_copy_day_args {
}

interface rpc_accept_meal_plan {
    name: 'rpc_accept_meal_plan';
    args: rpc_accept_meal_plan_args;
}

interface rpc_accept_meal_plan_args {
}

interface rpc_reject_meal_plan {
    name: 'rpc_reject_meal_plan';
    args: rpc_reject_meal_plan_args;
}

interface rpc_reject_meal_plan_args {
}

interface rpc_check_in {
    name: 'rpc_check_in';
    args: rpc_check_in_args;
}

interface rpc_check_in_args {
}

interface rpc_target_planner {
    name: 'rpc_target_planner';
    args: rpc_target_planner_args;
}

interface rpc_target_planner_args {
}

interface rpc_program_detail {
    name: 'rpc_program_detail';
    args: rpc_program_detail_args;
}

interface rpc_program_detail_args {
    form: string;
}

interface rpc_workouts {
    name: 'rpc_workouts';
    args: rpc_workouts_args;
}

interface rpc_workouts_args {
}

interface rpc_create_template_from_workout {
    name: 'rpc_create_template_from_workout';
    args: rpc_create_template_from_workout_args;
}

interface rpc_create_template_from_workout_args {
}

interface rpc_delete_workout_template {
    name: 'rpc_delete_workout_template';
    args: rpc_delete_workout_template_args;
}

interface rpc_delete_workout_template_args {
}

interface rpc_delete_workout {
    name: 'rpc_delete_workout';
    args: rpc_delete_workout_args;
}

interface rpc_delete_workout_args {
}

interface rpc_delete_group {
    name: 'rpc_delete_group';
    args: rpc_delete_group_args;
}

interface rpc_delete_group_args {
}

interface rpc_update_workout {
    name: 'rpc_update_workout';
    args: rpc_update_workout_args;
}

interface rpc_update_workout_args {
}

interface rpc_update_program {
    name: 'rpc_update_program';
    args: rpc_update_program_args;
}

interface rpc_update_program_args {
}

interface rpc_create_program {
    name: 'rpc_create_program';
    args: rpc_create_program_args;
}

interface rpc_create_program_args {
}

interface rpc_copy_program {
    name: 'rpc_copy_program';
    args: rpc_copy_program_args;
}

interface rpc_copy_program_args {
}

interface rpc_delete_program {
    name: 'rpc_delete_program';
    args: rpc_delete_program_args;
}

interface rpc_delete_program_args {
}

interface rpc_select_program_template {
    name: 'rpc_select_program_template';
    args: rpc_select_program_template_args;
}

interface rpc_select_program_template_args {
}

interface rpc_preview_program {
    name: 'rpc_preview_program';
    args: rpc_preview_program_args;
}

interface rpc_preview_program_args {
    form: string;
}

interface rpc_create_exercise_types {
    name: 'rpc_create_exercise_types';
    args: rpc_create_exercise_types_args;
}

interface rpc_create_exercise_types_args {
}

interface rpc_set_exercise_maxes {
    name: 'rpc_set_exercise_maxes';
    args: rpc_set_exercise_maxes_args;
}

interface rpc_set_exercise_maxes_args {
}

interface rpc_delete_exercise_type {
    name: 'rpc_delete_exercise_type';
    args: rpc_delete_exercise_type_args;
}

interface rpc_delete_exercise_type_args {
    source_exercise_type: string;
}

interface rpc_delete_exercise_group {
    name: 'rpc_delete_exercise_group';
    args: rpc_delete_exercise_group_args;
}

interface rpc_delete_exercise_group_args {
}

interface rpc_select_program_workout {
    name: 'rpc_select_program_workout';
    args: rpc_select_program_workout_args;
}

interface rpc_select_program_workout_args {
}

interface rpc_archive_program {
    name: 'rpc_archive_program';
    args: rpc_archive_program_args;
}

interface rpc_archive_program_args {
}

interface rpc_disable_sync {
    name: 'rpc_disable_sync';
    args: rpc_disable_sync_args;
}

interface rpc_disable_sync_args {
}

interface rpc_recent_sections {
    name: 'rpc_recent_sections';
    args: rpc_recent_sections_args;
}

interface rpc_recent_sections_args {
}

interface rpc_exercise_media_lookup {
    name: 'rpc_exercise_media_lookup';
    args: rpc_exercise_media_lookup_args;
}

interface rpc_exercise_media_lookup_args {
}

interface rpc_update_exercise_media {
    name: 'rpc_update_exercise_media';
    args: rpc_update_exercise_media_args;
}

interface rpc_update_exercise_media_args {
}

interface rpc_create_exercise_type {
    name: 'rpc_create_exercise_type';
    args: rpc_create_exercise_type_args;
}

interface rpc_create_exercise_type_args {
}

interface rpc_update_exercise_type {
    name: 'rpc_update_exercise_type';
    args: rpc_update_exercise_type_args;
}

interface rpc_update_exercise_type_args {
}

interface rpc_delete_exercise_set {
    name: 'rpc_delete_exercise_set';
    args: rpc_delete_exercise_set_args;
}

interface rpc_delete_exercise_set_args {
}

interface rpc_delete_exercise {
    name: 'rpc_delete_exercise';
    args: rpc_delete_exercise_args;
}

interface rpc_delete_exercise_args {
}

interface rpc_clear_exercise_sets {
    name: 'rpc_clear_exercise_sets';
    args: rpc_clear_exercise_sets_args;
}

interface rpc_clear_exercise_sets_args {
}

interface rpc_record_exercise_result {
    name: 'rpc_record_exercise_result';
    args: rpc_record_exercise_result_args;
}

interface rpc_record_exercise_result_args {
}

interface rpc_exercise_detail {
    name: 'rpc_exercise_detail';
    args: rpc_exercise_detail_args;
}

interface rpc_exercise_detail_args {
}

interface rpc_copy_workout {
    name: 'rpc_copy_workout';
    args: rpc_copy_workout_args;
}

interface rpc_copy_workout_args {
}

interface rpc_complete_workout {
    name: 'rpc_complete_workout';
    args: rpc_complete_workout_args;
}

interface rpc_complete_workout_args {
}

interface rpc_incomplete_workout {
    name: 'rpc_incomplete_workout';
    args: rpc_incomplete_workout_args;
}

interface rpc_incomplete_workout_args {
}

interface rpc_create_workout_template {
    name: 'rpc_create_workout_template';
    args: rpc_create_workout_template_args;
}

interface rpc_create_workout_template_args {
}

interface rpc_create_question_type {
    name: 'rpc_create_question_type';
    args: rpc_create_question_type_args;
}

interface rpc_create_question_type_args {
}

interface rpc_delete_entry {
    name: 'rpc_delete_entry';
    args: rpc_delete_entry_args;
}

interface rpc_delete_entry_args {
    form: string;
}

interface rpc_update_cupboard {
    name: 'rpc_update_cupboard';
    args: rpc_update_cupboard_args;
}

interface rpc_update_cupboard_args {
}

interface rpc_update_recipe {
    name: 'rpc_update_recipe';
    args: rpc_update_recipe_args;
}

interface rpc_update_recipe_args {
}

interface rpc_predictions_data {
    name: 'rpc_predictions_data';
    args: rpc_predictions_data_args;
}

interface rpc_predictions_data_args {
}

interface rpc_load_search {
    name: 'rpc_load_search';
    args: rpc_load_search_args;
}

interface rpc_load_search_args {
}

interface rpc_search {
    name: 'rpc_search';
    args: rpc_search_args;
}

interface rpc_search_args {
}

interface rpc_publish_nutritional_vision_prompt {
    name: 'rpc_publish_nutritional_vision_prompt';
    args: rpc_publish_nutritional_vision_prompt_args;
}

interface rpc_publish_nutritional_vision_prompt_args {
}

interface rpc_publish_day {
    name: 'rpc_publish_day';
    args: rpc_publish_day_args;
}

interface rpc_publish_day_args {
}

interface rpc_share_detail {
    name: 'rpc_share_detail';
    args: rpc_share_detail_args;
}

interface rpc_share_detail_args {
}

interface rpc_share_recipe {
    name: 'rpc_share_recipe';
    args: rpc_share_recipe_args;
}

interface rpc_share_recipe_args {
}

interface rpc_toggle_recipe_favorite {
    name: 'rpc_toggle_recipe_favorite';
    args: rpc_toggle_recipe_favorite_args;
}

interface rpc_toggle_recipe_favorite_args {
    form: string;
}

interface rpc_food_list {
    name: 'rpc_food_list';
    args: rpc_food_list_args;
}

interface rpc_food_list_args {
}

interface rpc_create_food {
    name: 'rpc_create_food';
    args: rpc_create_food_args;
}

interface rpc_create_food_args {
}

interface rpc_update_food {
    name: 'rpc_update_food';
    args: rpc_update_food_args;
}

interface rpc_update_food_args {
}

interface rpc_delete_food {
    name: 'rpc_delete_food';
    args: rpc_delete_food_args;
}

interface rpc_delete_food_args {
}

interface rpc_recipe_list {
    name: 'rpc_recipe_list';
    args: rpc_recipe_list_args;
}

interface rpc_recipe_list_args {
}

interface rpc_create_recipe {
    name: 'rpc_create_recipe';
    args: rpc_create_recipe_args;
}

interface rpc_create_recipe_args {
}

interface rpc_update_recipe_metadata {
    name: 'rpc_update_recipe_metadata';
    args: rpc_update_recipe_metadata_args;
}

interface rpc_update_recipe_metadata_args {
}

interface rpc_delete_recipe {
    name: 'rpc_delete_recipe';
    args: rpc_delete_recipe_args;
}

interface rpc_delete_recipe_args {
}

interface rpc_copy_recipe {
    name: 'rpc_copy_recipe';
    args: rpc_copy_recipe_args;
}

interface rpc_copy_recipe_args {
}

interface rpc_create_recipe_from_meal {
    name: 'rpc_create_recipe_from_meal';
    args: rpc_create_recipe_from_meal_args;
}

interface rpc_create_recipe_from_meal_args {
}

interface rpc_publish_meal {
    name: 'rpc_publish_meal';
    args: rpc_publish_meal_args;
}

interface rpc_publish_meal_args {
}

interface rpc_delete_meal {
    name: 'rpc_delete_meal';
    args: rpc_delete_meal_args;
}

interface rpc_delete_meal_args {
}

interface rpc_move_meal {
    name: 'rpc_move_meal';
    args: rpc_move_meal_args;
}

interface rpc_move_meal_args {
}

interface rpc_copy_meal {
    name: 'rpc_copy_meal';
    args: rpc_copy_meal_args;
}

interface rpc_copy_meal_args {
}

interface rpc_publish_entry {
    name: 'rpc_publish_entry';
    args: rpc_publish_entry_args;
}

interface rpc_publish_entry_args {
}

interface rpc_expand_entry {
    name: 'rpc_expand_entry';
    args: rpc_expand_entry_args;
}

interface rpc_expand_entry_args {
}

interface rpc_reports {
    name: 'rpc_reports';
    args: rpc_reports_args;
}

interface rpc_reports_args {
}

interface rpc_weekly_macros {
    name: 'rpc_weekly_macros';
    args: rpc_weekly_macros_args;
}

interface rpc_weekly_macros_args {
}

interface rpc_mfp_migration_detail {
    name: 'rpc_mfp_migration_detail';
    args: rpc_mfp_migration_detail_args;
}

interface rpc_mfp_migration_detail_args {
}

interface rpc_create_mfp_account {
    name: 'rpc_create_mfp_account';
    args: rpc_create_mfp_account_args;
}

interface rpc_create_mfp_account_args {
}

interface rpc_walking_club_board {
    name: 'rpc_walking_club_board';
    args: rpc_walking_club_board_args;
}

interface rpc_walking_club_board_args {
}

interface rpc_walking_club_demo_allowed {
    name: 'rpc_walking_club_demo_allowed';
    args: rpc_walking_club_demo_allowed_args;
}

interface rpc_walking_club_demo_allowed_args {
}

interface rpc_walking_club_info {
    name: 'rpc_walking_club_info';
    args: rpc_walking_club_info_args;
}

interface rpc_walking_club_info_args {
}

interface rpc_walking_club_login_link {
    name: 'rpc_walking_club_login_link';
    args: rpc_walking_club_login_link_args;
}

interface rpc_walking_club_login_link_args {
}

interface rpc_walking_club_join {
    name: 'rpc_walking_club_join';
    args: rpc_walking_club_join_args;
}

interface rpc_walking_club_join_args {
}

interface rpc_walking_club_registration {
    name: 'rpc_walking_club_registration';
    args: rpc_walking_club_registration_args;
}

interface rpc_walking_club_registration_args {
}

interface rpc_onboarding_registration {
    name: 'rpc_onboarding_registration';
    args: rpc_onboarding_registration_args;
}

interface rpc_onboarding_registration_args {
}

interface rpc_save_macros {
    name: 'rpc_save_macros';
    args: rpc_save_macros_args;
}

interface rpc_save_macros_args {
}

interface rpc_queue_meal_image {
    name: 'rpc_queue_meal_image';
    args: rpc_queue_meal_image_args;
}

interface rpc_queue_meal_image_args {
}

interface rpc_identify_meal_name {
    name: 'rpc_identify_meal_name';
    args: rpc_identify_meal_name_args;
}

interface rpc_identify_meal_name_args {
    form: string;
}

interface rpc_queue_barcode {
    name: 'rpc_queue_barcode';
    args: rpc_queue_barcode_args;
}

interface rpc_queue_barcode_args {
}

interface rpc_process_queued_barcode {
    name: 'rpc_process_queued_barcode';
    args: rpc_process_queued_barcode_args;
}

interface rpc_process_queued_barcode_args {
    form: string;
}

interface rpc_process_queued_image {
    name: 'rpc_process_queued_image';
    args: rpc_process_queued_image_args;
}

interface rpc_process_queued_image_args {
    form: string;
}

interface rpc_reprocess_queued_image {
    name: 'rpc_reprocess_queued_image';
    args: rpc_reprocess_queued_image_args;
}

interface rpc_reprocess_queued_image_args {
}

interface rpc_queue_audio_transcription {
    name: 'rpc_queue_audio_transcription';
    args: rpc_queue_audio_transcription_args;
}

interface rpc_queue_audio_transcription_args {
    form: string;
}

interface rpc_process_queued_audio {
    name: 'rpc_process_queued_audio';
    args: rpc_process_queued_audio_args;
}

interface rpc_process_queued_audio_args {
    form: string;
}

interface rpc_import_recipe {
    name: 'rpc_import_recipe';
    args: rpc_import_recipe_args;
}

interface rpc_import_recipe_args {
}

interface rpc_peptides {
    name: 'rpc_peptides';
    args: rpc_peptides_args;
}

interface rpc_peptides_args {
}

interface rpc_create_peptide_vial {
    name: 'rpc_create_peptide_vial';
    args: rpc_create_peptide_vial_args;
}

interface rpc_create_peptide_vial_args {
}

interface rpc_delete_peptide_vial {
    name: 'rpc_delete_peptide_vial';
    args: rpc_delete_peptide_vial_args;
}

interface rpc_delete_peptide_vial_args {
}

interface rpc_create_peptide_dose {
    name: 'rpc_create_peptide_dose';
    args: rpc_create_peptide_dose_args;
}

interface rpc_create_peptide_dose_args {
}

interface rpc_strength {
    name: 'rpc_strength';
    args: rpc_strength_args;
}

interface rpc_strength_args {
}

interface rpc_update_meet {
    name: 'rpc_update_meet';
    args: rpc_update_meet_args;
}

interface rpc_update_meet_args {
}

interface rpc_instacart_recipe {
    name: 'rpc_instacart_recipe';
    args: rpc_instacart_recipe_args;
}

interface rpc_instacart_recipe_args {
}

interface rpc_usda_foods {
    name: 'rpc_usda_foods';
    args: rpc_usda_foods_args;
}

interface rpc_usda_foods_args {
}

interface rpc_export_journal {
    name: 'rpc_export_journal';
    args: rpc_export_journal_args;
}

interface rpc_export_journal_args {
}

interface rpc_get_available_prediction_users {
    name: 'rpc_get_available_prediction_users';
    args: rpc_get_available_prediction_users_args;
}

interface rpc_get_available_prediction_users_args {
}

interface get_tus_upload_url {
    name: 'get_tus_upload_url';
    args: get_tus_upload_url_args;
}

interface get_tus_upload_url_args {
}

interface billing {
    name: 'billing';
    args: billing_args;
}

interface billing_args {
}

interface paypal_redirect {
    name: 'paypal_redirect';
    args: paypal_redirect_args;
}

interface paypal_redirect_args {
}

interface business_page {
    name: 'business_page';
    args: business_page_args;
}

interface business_page_args {
}

interface business_demo {
    name: 'business_demo';
    args: business_demo_args;
}

interface business_demo_args {
}

interface five_three_one {
    name: 'five_three_one';
    args: five_three_one_args;
}

interface five_three_one_args {
}

interface home_page {
    name: 'home_page';
    args: home_page_args;
}

interface home_page_args {
}

interface download {
    name: 'download';
    args: download_args;
}

interface download_args {
}

interface review_redirect {
    name: 'review_redirect';
    args: review_redirect_args;
}

interface review_redirect_args {
}

interface chandler {
    name: 'chandler';
    args: chandler_args;
}

interface chandler_args {
}

interface support_user {
    name: 'support_user';
    args: support_user_args;
}

interface support_user_args {
    user_id: number;
}

interface csrf {
    name: 'csrf';
    args: csrf_args;
}

interface csrf_args {
}

interface credentials {
    name: 'credentials';
    args: credentials_args;
}

interface credentials_args {
}

interface sync_sleep {
    name: 'sync_sleep';
    args: sync_sleep_args;
}

interface sync_sleep_args {
}

interface async_sleep {
    name: 'async_sleep';
    args: async_sleep_args;
}

interface async_sleep_args {
}

interface sesame_login {
    name: 'sesame_login';
    args: sesame_login_args;
}

interface sesame_login_args {
}

interface demo_setup {
    name: 'demo_setup';
    args: demo_setup_args;
}

interface demo_setup_args {
}

interface terms_of_service {
    name: 'terms_of_service';
    args: terms_of_service_args;
}

interface terms_of_service_args {
}

interface privacy_policy {
    name: 'privacy_policy';
    args: privacy_policy_args;
}

interface privacy_policy_args {
}

interface robots_txt {
    name: 'robots_txt';
    args: robots_txt_args;
}

interface robots_txt_args {
}

interface sitemap_xml {
    name: 'sitemap_xml';
    args: sitemap_xml_args;
}

interface sitemap_xml_args {
}

interface apple_app_site_association {
    name: 'apple_app_site_association';
    args: apple_app_site_association_args;
}

interface apple_app_site_association_args {
}

interface android_app_site_association {
    name: 'android_app_site_association';
    args: android_app_site_association_args;
}

interface android_app_site_association_args {
}

interface serve_static {
    name: 'serve_static';
    args: serve_static_args;
}

interface serve_static_args {
    path: string;
}

interface __reactivated_do_not_use {
    name: '__reactivated_do_not_use';
    args: __reactivated_do_not_use_args;
}

interface __reactivated_do_not_use_args {
}

interface __reactivated_do_not_use_args {
    name: '__reactivated_do_not_use_args';
    args: __reactivated_do_not_use_args_args;
}

interface __reactivated_do_not_use_args_args {
    _: string;
}

type WithArguments = |backoffice_module|track_email_open|hire_registration|program_redirect|confirm_manager|exercise_media_path|meet_detail|join_meet|share_debug|share_detail|peptide_open_graph|peptide_guide|super_smoothies_detail|walking_club_open_graph|walking_club_detail|password_reset_confirm|any_client_delete|client_detail|meal_plan_detail|meal_plan_delete|client_planner|client_planner_targets_create|client_planner_targets|program_detail|client_check_ins|client_survey|client_reports|client_days|client_supplements|rpc_link_analytics|rpc_update_day|rpc_verify_purchase_entitlement|rpc_program_detail|rpc_preview_program|rpc_delete_exercise_type|rpc_delete_entry|rpc_toggle_recipe_favorite|rpc_identify_meal_name|rpc_process_queued_barcode|rpc_process_queued_image|rpc_queue_audio_transcription|rpc_process_queued_audio|support_user|serve_static|__reactivated_do_not_use_args;
type WithoutArguments = |mcp_register|mcp_authorize|mcp_token|mcp_icon|mcp|hijack_acquire|hijack_release|backoffice_predictions|client_registration|manager_registration|redirect_to_client_dashboard|merge_exercises|exercise_media|strength|strength_open_graph|pull_up|leangains|start|migrate|contact|tutorials|share|peptides|super_smoothies|storyboard|journal|calculator|macros|workouts|profile|login|plan_onboarding|walking_club|register|reset|load_search_async|clients_list|business_create|clients_settings|business_billing|meal_plans_list|meal_plans_create|programs_list|clients_check_ins|clients_profiles|rpc_profile_detail|rpc_register|rpc_check_email|rpc_login|rpc_set_password|rpc_update_settings|rpc_apple_ping|rpc_track_email_click|rpc_register_apns_device|rpc_preview_email|rpc_postmark_webhook|rpc_mfp_registration|rpc_learning_week_registration|rpc_plan_registration|rpc_create_user_media_image|rpc_request_login_link|rpc_validate_login_link|rpc_logout|rpc_reset_password|rpc_contact|rpc_dismiss_announcement|rpc_update_profile|rpc_delete_profile|rpc_get_client_dashboard_link|rpc_invite_user|rpc_attribute_share|rpc_attribute_utm|rpc_create_tracking_link|rpc_create_calculator_share|rpc_validate_iap|rpc_verify_apple_transaction|rpc_apple_notification|rpc_subscription_detail|rpc_create_subscription|rpc_delete_subscription|rpc_create_paypal_subscription|rpc_save|rpc_update_metrics|rpc_update_metric_aggregates|rpc_update_metric_aggregates_native|rpc_journal|rpc_update_measurements|rpc_legacy_update_day|rpc_delete_journal_workout|rpc_fast_init|rpc_planner|rpc_consumer_planner|rpc_start|rpc_method|rpc_reset_challenge|rpc_shopify_order_created|rpc_replace_entry|rpc_move_day|rpc_copy_day|rpc_accept_meal_plan|rpc_reject_meal_plan|rpc_check_in|rpc_target_planner|rpc_workouts|rpc_create_template_from_workout|rpc_delete_workout_template|rpc_delete_workout|rpc_delete_group|rpc_update_workout|rpc_update_program|rpc_create_program|rpc_copy_program|rpc_delete_program|rpc_select_program_template|rpc_create_exercise_types|rpc_set_exercise_maxes|rpc_delete_exercise_group|rpc_select_program_workout|rpc_archive_program|rpc_disable_sync|rpc_recent_sections|rpc_exercise_media_lookup|rpc_update_exercise_media|rpc_create_exercise_type|rpc_update_exercise_type|rpc_delete_exercise_set|rpc_delete_exercise|rpc_clear_exercise_sets|rpc_record_exercise_result|rpc_exercise_detail|rpc_copy_workout|rpc_complete_workout|rpc_incomplete_workout|rpc_create_workout_template|rpc_create_question_type|rpc_update_cupboard|rpc_update_recipe|rpc_predictions_data|rpc_load_search|rpc_search|rpc_publish_nutritional_vision_prompt|rpc_publish_day|rpc_share_detail|rpc_share_recipe|rpc_food_list|rpc_create_food|rpc_update_food|rpc_delete_food|rpc_recipe_list|rpc_create_recipe|rpc_update_recipe_metadata|rpc_delete_recipe|rpc_copy_recipe|rpc_create_recipe_from_meal|rpc_publish_meal|rpc_delete_meal|rpc_move_meal|rpc_copy_meal|rpc_publish_entry|rpc_expand_entry|rpc_reports|rpc_weekly_macros|rpc_mfp_migration_detail|rpc_create_mfp_account|rpc_walking_club_board|rpc_walking_club_demo_allowed|rpc_walking_club_info|rpc_walking_club_login_link|rpc_walking_club_join|rpc_walking_club_registration|rpc_onboarding_registration|rpc_save_macros|rpc_queue_meal_image|rpc_queue_barcode|rpc_reprocess_queued_image|rpc_import_recipe|rpc_peptides|rpc_create_peptide_vial|rpc_delete_peptide_vial|rpc_create_peptide_dose|rpc_strength|rpc_update_meet|rpc_instacart_recipe|rpc_usda_foods|rpc_export_journal|rpc_get_available_prediction_users|get_tus_upload_url|billing|paypal_redirect|business_page|business_demo|five_three_one|home_page|download|review_redirect|chandler|csrf|credentials|sync_sleep|async_sleep|sesame_login|demo_setup|terms_of_service|privacy_policy|robots_txt|sitemap_xml|apple_app_site_association|android_app_site_association|__reactivated_do_not_use;


    type All = WithArguments|WithoutArguments;
    export function reverse<T extends WithoutArguments['name']>(name: T): string;
    export function reverse<T extends WithArguments['name']>(name: T, args: Extract<WithArguments, {name: T}>['args']): string;
    export function reverse<T extends All['name']>(name: T, args?: Extract<WithArguments, {name: T}>['args']): string {
        let route = urls[name].route;

        if (args != null) {
            for (const token of Object.keys(args)) {
                route = route.replace(new RegExp('<(.+?:)' + token + '>'), (args as any)[token]);
            }
        }
        return route;
    }
